import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/content';
export function Transformation() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8" data-id="element-226" data-mp="il2ojkleblxq">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-227" data-mp="mlmjqimesfh8">
        <Reveal data-id="element-228" data-mp="moh6whwt4eec">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-level-green" data-id="element-229" data-mp="rkz8j8wubwmg">
            Ett bättre sätt att undervisa innebandy
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-230" data-mp="wihjt5ybynxm">
          <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl md:text-[42px]" data-id="element-231" data-mp="11ivgjruhebgc">
            Från en överväldigad lärare eller tränare till en{' '}
            <span className="font-serif italic font-normal text-level-blue" data-id="element-232" data-mp="1abgwz1an4620">
              trygg innebandy-guide
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.12} data-id="element-233" data-mp="1fcmpoz4avtbj">
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted" data-id="element-234" data-mp="1k9mz9k0cze7e">
            Innebandy Ready förvandlar timmar av planering till ett system du bara öppnar
            och kör. Gå in i varje lektion eller träning med en tydlig plan, meningsfulla
            övningar och tryggheten att få innebandyn att hända — oavsett om du är
            idrottslärare eller klubbtränare.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.18} className="mx-auto mt-12 w-full max-w-3xl" data-id="element-235" data-mp="y7afeulrnwak">
        <div className="grid grid-cols-1 divide-y divide-sand rounded-3xl border border-sand bg-white px-8 py-8 sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-236" data-mp="1ux1buzdmbtj0">
          {transformationStats.map(stat => <div key={stat.label} className="flex flex-col items-center px-4 py-5 text-center sm:py-0" data-id="element-237" data-mp="1m3o8f3hxh9io">
              <p className="font-serif text-4xl leading-none text-navy" data-id="element-238" data-mp="1h4uxniu0zwm7">{stat.value}</p>
              <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-239" data-mp="2em20emgl219u">
                {stat.label}
              </p>
            </div>)}
        </div>
      </Reveal>
    </section>;
}